/**
 * Single-select industry filter for the Case Studies List block.
 *
 * All case studies are already rendered server-side (SEO-safe, no AJAX).
 * Clicking a filter button just shows/hides the already-present rows by
 * matching the button's slug against each row's data-industry list.
 *
 * @param {HTMLElement} block Block root element.
 */
const initCaseStudiesFilter = ( block ) => {

	const filterButtons = block.querySelectorAll( '[data-case-studies-filter]' );
	const items          = block.querySelectorAll( '[data-case-studies-item]' );
	const status         = block.querySelector( '[data-case-studies-status]' );
	const labelSingular  = status?.dataset.labelSingular || '';
	const labelPlural    = status?.dataset.labelPlural || '';

	if ( ! filterButtons.length || ! items.length ) {

		return;

	}

	/**
	 * Shows/hides rows for the given industry slug ('' shows everything),
	 * updates pressed state on the filter buttons, and announces the count.
	 *
	 * @param {string} slug Industry slug to filter by, or '' for all.
	 */
	const applyFilter = ( slug ) => {

		let visibleCount = 0;

		items.forEach( ( item ) => {

			const industries = ( item.dataset.industry || '' ).split( ' ' );
			const isVisible  = ! slug || industries.includes( slug );

			item.hidden = ! isVisible;

			if ( isVisible ) {

				visibleCount += 1;

			}

		} );

		filterButtons.forEach( ( button ) => {

			const isActive = button.dataset.caseStudiesFilter === slug;
			button.classList.toggle( 'is-active', isActive );
			button.setAttribute( 'aria-pressed', isActive ? 'true' : 'false' );

		} );

		if ( status ) {

			status.textContent = visibleCount === 1
				? labelSingular
				: labelPlural.replace( '%d', String( visibleCount ) );

		}

	};

	filterButtons.forEach( ( button ) => {

		button.addEventListener( 'click', () => applyFilter( button.dataset.caseStudiesFilter || '' ) );

	} );

};

document.querySelectorAll( '.b-case-studies-list' ).forEach( initCaseStudiesFilter );
